import React, { useState, useEffect, useRef } from 'react';
import PopUp from '../../Shared/Popup/PopUp';
import EpiContext from '@episerver/spa-core/Spa';
import {
    abroadCountriesSearched,
    setLoading,
    updateTicketFromPackageManager,
    saveToHistory,
    setChosenSocForAction,
    clearScreenILAddon,
    filterCustomerFromBoughtPackages,
    resetFamilyBundleData,
    setSelectedMembers,
    setFamilyBundleErrorType,
    setFamilyBundleFailedMembers,
    clearPurchasedFamilyBundleData,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { connect, useDispatch } from 'react-redux';
import { removePackage, updatePackage, getCustomerAbroadPackages } from '../CellcomAbroadLobbyBlock/Shared/abroadThunk';
import { isMobile, isBrowser } from 'react-device-detect';
import CancelPackagePopUp from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/CancelPackagePopUp';
import CannotCancelWhileAbroad from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/CannotCancelWhileAbroad';
import CantChangeStartDateFamilyOrCanCancelFamily from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/CantChangeStartDateFamilyOrCanCancelFamily';
import { gaEvent } from '../../../utilities/analytics/tracking';
import gaParams from '../../../utilities/analytics/constants';
import {
    formatDatesToDifferentFormats,
    formatDateToMonthFirst,
    getDayBeforeAndAfter,
    getPackageEndDate,
    formatPackageDurationLabel,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';
import FailedUpdatePackage from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/FailedUpdatePackage';
import FailedCancelPackage from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/FailedCancelPackage';
import ImportantPart from '../CellcomAbroadLobbyBlock/Shared/Components/ImportantPart';
import { customerTypeEnum, toolTipFamily } from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import { AbroadSocType, AddonType } from '../CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';
import AddonsCancellationNoticePopup from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/AddonsCancellationNoticePopup';
import { dwhRemoveAbroadAddon, dwhAbroadAddonExistingPage, dwhRemoveAbroadAddonSameDay } from '../CellcomAbroadLobbyBlock/dwhReports';
import CountryPopUp from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/CountryPopUp';
import { gaCancelAddonsStep1, gaExistingAddons } from '../AbroadTicketBlock/gaReports';
import images from '../CellcomAbroadLobbyBlock/PackageExists/images/images';
import Config from '../../../Config';
import CancelAddonPackagePopUp from '../CellcomAbroadLobbyBlock/PackageExists/PopUps/CancelAddonPackagePopUp';
import ChangeStartPackageDatePopup from '../CellcomAbroadLobbyBlock/Popups/ChangeStartPackageDatePopup';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';
import AbroadStateInclude from '../CellcomAbroadLobbyBlock/Shared/Components/AbroadStateInclude';
import AbroadTooltip from '../CellcomAbroadLobbyBlock/Shared/Components/Tooltip/AbroadTooltip';
import CalendarIcon from './images/calender.svg';
import addIcon from './images/add-icon.svg';
import tooltipIcon from './images/tooltipIcon.svg';
import marker from './images/marker.svg';
import dot from './images/dot.svg';
import { setRetainSubscriberOnLoad, resetSocPackageRemoveStatus, invalidateAbroadDataForSubscriber, setCallbackAfterExtendedLogin, resetAllAbroadSubscribers ,setReducedSocsForFamilyMember } from 'app/Components/Page/SelfCarePage/SelfCareSlice';
import editIcon from './images/editIcon.svg';
import userIcon from './images/userIcon.svg';
import moreInfoIcon from './images/moreInfo.svg';
import CustomTooltip from '../../Shared/CustomToolTip/CustomTooltip';
import noticeIcon from './images/light.svg';
import SelectFamilyMembersPopup from '../AbroadTicketBlock/Popups/SelectFamilyMembersPopup';
import PackageCanceledPopup from '../CellcomAbroadLobbyBlock/Popups/PackageCanceledPopup';
import FamilyBundleErrorPopup from '../CellcomAbroadLobbyBlock/Popups/FamilyBundleErrorPopup';
import calendarIcon from './images/calendar.svg';
import PopUpWithAnimation from '../../Shared/PopUpWithAnimation/PopUpWithAnimation';
import OtpExtendedPopup from '../SelfcareExtendedOtpButtonBlock/PopUp/OtpExtendedPopup';
import { getSelfCareData, Onboarding } from '../../Page/SelfCarePage/SelfCareAsyncThunk';
import { parseToDate } from '../../../utilities/dateUtils.js';
import Image from 'app/Components/Shared/Image/image';
import confettiDesktop from './images/ConfettiDesktop.svg';
import confettiMobile from './images/ConfettiMobile.svg';
import { getDataFromIContentRepo, buildUrlAndNavigate} from '../../../utilities/StringHelpers/StringHelpers';
function SelfCareExistingPackage({
    cellcomAbroad,
    setLoading,
    customerAbroadPackages,
    updateTicketFromPackageManager,
    context,
    packageData,
    otpData,
    removePackage,
    socPackageRemoveStatus,
    businessId,
    privateId,
    goldBusinessSocPackageFolderId,
    mobile,
    updatePackage,
    updatedSocResultStatus,
    resetSocPackageRemoveStatus,
    invalidateAbroadDataForSubscriber,
    chosenSocForAction,
    setChosenSocForAction,
    isBusinessIndividual,
    portalsBlock,
    userData,
    clearScreenILAddon,
    iContent,
    abroadWorld,
    filterCustomerFromBoughtPackages,
    saveToHistory,
    selfCareAbroadPackages,
    selfcareAbroadAddons,
    setRetainSubscriberOnLoad,
    removePackageSucceded,
    socPackageRemoveErrorCode,
    purchasedFamilyBundleData,
    cellularSubscribers,
    resetFamilyBundleData,
    familyBundleData,
    setSelectedMembers,
    lobbyBlockId,
    getCustomerAbroadPackages,
    authentication,
    callbackAfterExtendedLogin,
    setCallbackAfterExtendedLogin,
    setReducedSocsForFamilyMember
}) {
    const isDefault = packageData?.isDefault || false;
    const [arrowOpen, setArrowOpen] = useState(isDefault);
    const [popUpDisplay, setPopUpDisplay] = useState('');
    const dispatch = useDispatch();
    const [extraTopShouldShow, setExtraTopShouldShow] = useState(null);
    const [familyMembersEditMode, setFamilyMembersEditMode] = useState('edit');


    const hasImportantDataText = checkHasImportantData();
    const packageDuration = packageData?.abroadPackageClient?.packageDuration;
    const packageDurationUnit = packageData?.abroadPackageClient?.packageDurationUnit;
    const hasStateIncludes = packageData?.abroadPackageClient?.countrySupportedDictionary;
    const packageSocCode = packageData?.abroadPackageClient?.socCode;
    const packageBlockId = packageData?.abroadPackageClient?.blockId;
    const packageTitle = packageData.customTitle ? packageData.customTitle : 'חבילת חו"ל';
    const linkForSaleBlockProcess = Config.staticWebSiteUrl + getDataFromIContentRepo('linkForAbroadTicket')?.url;
    const linkForRelatedReducedPackages = Config.staticWebSiteUrl + getDataFromIContentRepo('linkForReducedPackages')?.url;
    const reducedSocs = packageData?.abroadPackageClient?.reducedSocs;
    const HasReducedSocs = reducedSocs?.reducedSocList?.length>0;

    const popUpObject = {
        showInfoPopUp: 'showInfoPopUp',
        showCancelPackagePopUp: 'showCancelPackagePopUp',
        showAddonsCancellationNoticePopUp: 'showAddonsCancellationNoticePopUp',
        showChangeStartDateFamily: 'showChangeStartDateFamily',
        cantChangeStartDateFamilyOrCanCancelFamily: 'CantChangeStartDateFamilyOrCanCancelFamily',
        showCountriesPopUp: 'showCountriesPopUp',
        failedUpdatePackage: 'failedUpdatePackage',
        updateTripDate: 'updateTripDate',
        showYouCannotCancelPackagePopUp: 'showYouCannotCancelPackagePopUp',
        buyExtendedPackage: 'buyExtendedPackage',
        displayStateInclude: 'displayStateInclude',
        failedCancelPackage: 'FailedCancelPackage',
        showCannotCancelWhileAbroadPopUp: 'showCannotCancelWhileAbroadPopUp',
        showFamilyMembersPopup: 'showFamilyMembersPopup',
        showFamilyBundleError: 'showFamilyBundleError',
        showPackageCanceledPopup: 'showPackageCanceledPopup',
    };

    const canCancelPackage = packageData.permissions?.canCancelPurchuse;
    const canCancelPackageFamily = packageData.permissions?.canCancelPurchaseFamily;
    const canChangeStartDatePackageFamily = packageData.permissions?.canChangeTripStartDateFamily;
    const canSeeCancel = packageData.permissions?.shouldShowCancelBtn;
    const dateTxt = packageData?.effDateILLocalTime ? packageData.effDateILLocalTime : new Date().toLocaleDateString('He-IL');
    const hasFamilyBonus = packageData?.abroadPackageClient?.isGiveFamilyBonus || false;
    const discountedPackage = packageData?.familyMemberDiscountedPackage || null;
    const familyMembersWithPackages = packageData?.familyMembersWithPackages || [];
    const canPurchaseFamilyPackage = packageData?.canPurchaseFamilyPackage || false;
    let maxFamilyMembers = 5; // regular family package
    const addonsUnderPackage = getAddonsNameUnderPackage();
    //dwh
    const params = {
        channel: cellcomAbroad.activeLobbyTab && cellcomAbroad.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
        param1: cellcomAbroad.isJETAuthentication ? 'JET' : 'WEBSITE',
        param2: packageSocCode,
        param3: cellcomAbroad.selectedAbroadPackage?.isFamilyBonus
            ? 'בני משפחות'
            : cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
                ? 'Individual'
                : '',
        param4: userData?.contactNumber,
        param5: cellcomAbroad.selectedCountries.map((c) => c.countryCode).join(','),
        costumerName: userData?.firstName + ' ' + userData?.lastName,
        idNumber: userData?.IDNumber,
        subscriber: mobile,
    };

    const [showOtpExtendedPopup, setShowOtpExtendedPopup] = useState(false);
    const [otpExtendedDone, setOtpExtendedDone] = useState(false);

    // Check if user is in OTP mode (not full or OTP extended)
    const isOtpMode = (authentication?.loginData?.isOtpAuthenticated &&
        !authentication?.loginData?.isFullAuthenticated &&
        !authentication?.loginData?.isOtpExtendedAuthenticated);

    const isPackageActive = (effectiveFromDateString) => {
        const effectiveDate = parseToDate(effectiveFromDateString);

        if (!effectiveDate) {
            return false;
        }

        return effectiveDate > new Date();
    }

    useEffect(() => {
        if (familyBundleData?.errorType !== 'members') {
            resetFamilyBundleData();
        }
    }, []);

    useEffect(() => {
        if (packageData.socEffactiveDate && checkEffDateBiggerThenToday()) {
            setExtraTopShouldShow(true);
        }
        gaEvent(
            gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_DISPLAY.category,
            gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_DISPLAY.eventType,
            packageSocCode,
        );
        if (packageData.socType == AbroadSocType.ADDON_SOC) {
            dwhAbroadAddonExistingPage({
                message: 'Existing Addon Displayed',
                ...params,
            });
            gaExistingAddons(packageTitle);
        }
    }, []);

    useEffect(() => {
        if (popUpDisplay === popUpObject.updateTripDate) {
            gaEvent(
                gaParams.ABROAD_MY_ABROAD_DISPLAY_CHANGE_START_DATE_POP_UP.category,
                gaParams.ABROAD_MY_ABROAD_DISPLAY_CHANGE_START_DATE_POP_UP.eventType,
                gaParams.ABROAD_MY_ABROAD_DISPLAY_CHANGE_START_DATE_POP_UP.eventParams,
            );
        }
    }, [popUpDisplay]);


    const isMounted = useRef(true);
    useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);
    const prevRemovePackageSuccRef = useRef(removePackageSucceded);
    const prevSocRemoveStatusRef = useRef(socPackageRemoveStatus);

    useEffect(() => {
        const chosenTrim = chosenSocForAction?.trim();
        const packageTrim = packageSocCode?.trim();

        const prevRemove = prevRemovePackageSuccRef.current;
        const prevSoc = prevSocRemoveStatusRef.current;

        // Detect failure transition (not previously false -> now false)
        if ((removePackageSucceded === false && prevRemove !== false) || (socPackageRemoveStatus === false && prevSoc !== false)) {
            if (chosenTrim === packageTrim) {
                if (socPackageRemoveErrorCode === 'ABROAD_ACTIVE_PACKAGE') {
                    if (isMounted.current) setPopUpDisplay(popUpObject.showCannotCancelWhileAbroadPopUp);
                } else {
                    if (isMounted.current) setPopUpDisplay(popUpObject.failedCancelPackage);
                }
            }
        }

        // Detect success transition (not previously true -> now true)
        if ((removePackageSucceded === true && prevRemove !== true) || (socPackageRemoveStatus === true && prevSoc !== true)) {
            if (chosenTrim === packageTrim) {
                if (isMounted.current) {
                    setPopUpDisplay(popUpObject.showPackageCanceledPopup);
                }
            }
        }

        // update prev refs
        prevRemovePackageSuccRef.current = removePackageSucceded;
        prevSocRemoveStatusRef.current = socPackageRemoveStatus;
    }, [removePackageSucceded, socPackageRemoveErrorCode, chosenSocForAction, socPackageRemoveStatus]);

    useEffect(() => {
        if (updatedSocResultStatus === false && chosenSocForAction?.trim() === packageSocCode?.trim()) {
            if (isMounted.current) setPopUpDisplay(popUpObject.failedUpdatePackage);
        }
    }, [updatedSocResultStatus, chosenSocForAction]);

    useEffect(() => {
        if (familyBundleData?.errorType === 'members' && isMounted.current && packageData?.isFamilyBundle) {
            setPopUpDisplay(popUpObject.showFamilyBundleError);
        }
    }, [familyBundleData?.errorType]);

    useEffect(() => {
        if (otpExtendedDone) {
            if (callbackAfterExtendedLogin === "handleEditFamilyMembers") {
                handleEditFamilyMembers();
            } else if (callbackAfterExtendedLogin === "handleAddFamilyMembers") {
                handleAddFamilyMembers();
            }
            setCallbackAfterExtendedLogin("");
        }
    }, [otpExtendedDone]);

    useEffect(() => {
        if (callbackAfterExtendedLogin && callbackAfterExtendedLogin != '') {
            switch (callbackAfterExtendedLogin) {
                case "handleEditFamilyMembers":
                case "handleAddFamilyMembers":
                    setOtpExtendedDone(true);
                    break;
            }

            setCallbackAfterExtendedLogin("");
        }
    }, []);



    function checkHasImportantData() {
        if (
            Array.isArray(packageData?.abroadPackageClient?.importantInfo) &&
            packageData?.abroadPackageClient?.importantInfo.length > 0 &&
            packageData.abroadPackageClient?.importantInfo.every((el) => el != null)
        ) {
            return true;
        } else {
            return false;
        }
    }

    function expendData() {
        gaEvent(
            gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_EXPAND.category,
            gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_EXPAND.eventType,
            packageSocCode,
        );
        setArrowOpen(!arrowOpen);
    }
    function getAddonsNameUnderPackage() {
        var CouponPurchasedUnderPackage =
            selfcareAbroadAddons
                ?.filter((addon) => addon.parentSocCode == packageSocCode.trim() && addon.type == AddonType.Coupon && addon.isPurchased)
                ?.map((addon) => addon.packageName) || [];
        var abroadAddonsUnderPackageNames =
            selfCareAbroadPackages
                ?.filter((pack) => pack.socName == packageSocCode.trim() && pack.socType == AbroadSocType.ADDON_SOC)
                ?.map((addon) => addon.customTitle) || [];
        var addonsNames = [...abroadAddonsUnderPackageNames, ...CouponPurchasedUnderPackage];
        return addonsNames;
    }
    function changeDateToJSFormat() {
        const passDate = packageData.socEffactiveDate
            ? `${packageData.socEffactiveDate[4]}${packageData.socEffactiveDate[5]}/${packageData.socEffactiveDate[6]}${packageData.socEffactiveDate[7]}/${packageData.socEffactiveDate[0]}${packageData.socEffactiveDate[1]}${packageData.socEffactiveDate[2]}${packageData.socEffactiveDate[3]}`
            : new Date().toLocaleDateString().replaceAll('.', '-');
        return passDate;
    }

    function getFamilyMembersPopupStartDate() {
        if (familyMembersEditMode === 'add') {
            return formatDatesToDifferentFormats(new Date()).formattedProvider;
        }
        return formatDatesToDifferentFormats(changeDateToJSFormat())?.formattedProvider || changeDateToJSFormat();
    }

    async function cancelPackage() {
        if (packageData.socType == AbroadSocType.ADDON_SOC) {
            gaCancelAddonsStep1(packageSocCode);
        }
        gaEvent(
            gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.category,
            gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.eventType,
            gaParams.ABROAD_MY_ABROAD_CLICK_CANCEL_PACKAGE_POP_UP.eventParams,
        );
        const removeSocData = {
            soc: packageSocCode,
            mobile: mobile,
            startDate: packageData.socEffactiveDate,
            blockId: packageBlockId,
            isAddon: packageData.socType == AbroadSocType.ADDON_SOC,
        };

        setChosenSocForAction(packageSocCode);

        const packageInStore = selfCareAbroadPackages?.find(pkg => pkg.socName?.trim() === packageSocCode?.trim());
        let isSameDayAsPackageStart = false;

        if (packageInStore?.socEffactiveDate) {
            const today = new Date();
            //convert to Date
            const year = packageInStore.socEffactiveDate.substring(0, 4);
            const month = packageInStore.socEffactiveDate.substring(4, 6);
            const day = packageInStore.socEffactiveDate.substring(6, 8);
            const packageStartDate = new Date(year, parseInt(month) - 1, day);

            isSameDayAsPackageStart = today.toDateString() === packageStartDate.toDateString();
        }

        await removePackage(removeSocData).then((res) => {
            if (res.payload?.Body.isSuccess && isSameDayAsPackageStart) {
                dwhRemoveAbroadAddonSameDay({
                    message: 'Success',
                    status: 'Completed',
                    ...params,
                });
            }
            if (packageData.socType == AbroadSocType.ADDON_SOC) {
                if (res.payload?.Body.isSuccess) {
                    dwhRemoveAbroadAddon({
                        message: 'Success',
                        status: 'Completed',
                        ...params,
                    });
                } else {
                    dwhRemoveAbroadAddon({
                        message: 'General Error',
                        status: 'Error',
                        ...params,
                    });
                }
            }
            if (res.payload?.Body?.isSuccess) {
                if (isMounted.current) {
                    setPopUpDisplay(popUpObject.showPackageCanceledPopup);
                }
            } else if (isMounted.current) {
                if (res.payload?.Body?.codeError === 'ABROAD_ACTIVE_PACKAGE') {
                    setPopUpDisplay(popUpObject.showCannotCancelWhileAbroadPopUp);
                } else {
                    setPopUpDisplay(popUpObject.failedCancelPackage);
                }
            }
        });

    }

    function displayCancelPopUpAndReportGA() {
        gaEvent(
            gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_REMOVE_PACKAGE.category,
            gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_REMOVE_PACKAGE.eventType,
            packageSocCode,
        );
        if (packageData.socType == AbroadSocType.ADDON_SOC) {
            dwhAbroadAddonExistingPage({
                message: 'Addon Cancel Button Clicked',
                ...params,
            });
        }
        if (!canSeeCancel) {
            return;
        }

        if (!canCancelPackage) {
            setPopUpDisplay(popUpObject.showYouCannotCancelPackagePopUp);
            return;
        }

        const showCancelPopUp = addonsUnderPackage?.length > 0 ?
            popUpObject.showAddonsCancellationNoticePopUp :
            popUpObject.showCancelPackagePopUp;

        if (packageData.abroadPackageClient?.isGiveFamilyBonus && !canCancelPackageFamily) {
            setPopUpDisplay(popUpObject.cantChangeStartDateFamilyOrCanCancelFamily);
        } else {
            setPopUpDisplay(showCancelPopUp);
        }
    }

    function checkEffDateBiggerThenToday() {
        const effDate = new Date(formatDateToMonthFirst(packageData.socEffactiveDate));
        const today = new Date();
        return effDate > today;
    }

    function hasSevenDaysPassedSinceEffectiveDate() {
        const effDate = new Date(formatDateToMonthFirst(packageData.socEffactiveDate));
        const today = new Date();
        const daysDifference = Math.floor((today - effDate) / (1000 * 60 * 60 * 24));
        return daysDifference >= 7;
    }

    function setShowCountriesPopUpAndReportGA() {
        gaEvent(
            gaParams.ABROAD_MY_ABROAD_PACKAGE_CLICK_HOW_DIFF_STATE_PRICE.category,
            gaParams.ABROAD_MY_ABROAD_PACKAGE_CLICK_HOW_DIFF_STATE_PRICE.eventType,
            packageSocCode,
        );
        setPopUpDisplay(popUpObject.showCountriesPopUp);
    }

    function renderExpendedData(packageData) {
        const defaultOrByUse = packageData.isDefault === true || packageData.abroadPackageClient.isBankOrByUse == 'ByUse';
        return (
            <div className='expended-data-container'>
                {defaultOrByUse && (
                    <div className='expended-line' onClick={() => setShowCountriesPopUpAndReportGA()}>
                        {'תעריף לפי מדינות > '}
                    </div>
                )}
                {hasImportantDataText && !defaultOrByUse ? (
                    <div className='expended-line' onClick={() => setPopUpDisplay(popUpObject.showInfoPopUp)}>
                        {'חשוב לדעת > '}
                    </div>
                ) : (
                    <div
                        className='expended-line'
                        onClick={() => (packageData.abroadPackageClient?.policiesEpi ? openAgreementPDF() : showBusinessTerms())}>
                        {'חשוב לדעת > '}
                    </div>
                )}
                {hasStateIncludes && packageData?.abroadPackageClient?.isBankOrByUse != 'ByUse' && (
                    <div className='expended-line' onClick={() => setPopUpDisplay(popUpObject.displayStateInclude)}>
                        {'מדינות הכלולות בחבילה > '}
                    </div>
                )}
            </div>
        );
    }

    function displayPackageText() {
        if (packageData.abroadPackageClient.isBankOrByUse == 'ByUse' || packageData.abroadPackageClient.isDefault)
            return 'במסלול זה התעריף שונה בין המדינות';
    }
    function renderPackageDuration(anyData) {
        if (packageData.isAutoPackage) return null;
        if (packageData.abroadPackageClient.isDefault) {
            return (
                <div className='package-duration'>
                    <div className='package-duration-line-and-icon'>
                        <div className='package-duration-icon'>
                            <Image src={CalendarIcon} className='calendar-icon' />
                        </div>
                        <div className={`package-duration-line`}>החבילה תקפה לכל הנסיעה</div>
                    </div>
                </div>
            );
        }
    }

    function renderPackageData(packageData) {
        if (packageData.abroadPackageClient.isDefault) {
            return (
                <>
                    <div className='package-data-line'>
                        <div className='package-text'>{displayPackageText(packageData)}</div>
                        {renderPackageDuration(true)}
                    </div>
                    {arrowOpen && renderExpendedData(packageData)}
                </>
            );
        }
        const packageContainsData =
            packageData.abroadPackageClient && Array.isArray(packageData.abroadPackageClient.packageDetailsList)
                ? packageData.abroadPackageClient.packageDetailsList[0]
                : '';
        const sms = packageContainsData.sms?.unit ? 'SMS' : '';
        const voice = packageContainsData.voice?.unit ? 'דקות' : '';
        const data = packageContainsData.data?.unit != null ? packageContainsData.data.unit : '';
        const allOfData = data && sms && voice;
        const anyData = data || sms || voice;
        const byUseText =
            packageData.abroadPackageClient.isBankOrByUse == 'ByUse' || packageData.abroadPackageClient.isDefault ? (
                <span
                    className={packageData.abroadPackageClient.isBankOrByUse == 'ByUse' ? 'no-details-list-package-text' : ''}
                    style={packageData.abroadPackageClient.isBankOrByUse == 'ByUse' ? { marginLeft: '25px' } : {}}>
                    {displayPackageText()}
                </span>
            ) : null;

        return (
            <>
                <div className='package-data-line'>
                    <div className='package-text'>
                        {data && (
                            <div className='internet-data'>
                                {packageContainsData.data?.value}
                                {data}
                            </div>
                        )}
                        {sms && data && <div className='vertical-line'></div>}
                        {sms && (
                            <div className='sms-data'>
                                <div className='unit'>{sms}</div>
                                &nbsp;
                                <div className='unit-value'>{packageContainsData.sms?.value}</div>
                            </div>
                        )}
                        {voice && data && <div className='vertical-line'></div>}
                        {voice && (
                            <div className='voice-data'>
                                {packageContainsData.voice?.value}&nbsp;{voice}
                            </div>
                        )}
                        {byUseText}
                    </div>
                    {renderPackageDuration(anyData)}
                </div>
                {arrowOpen && displayPackageExpandedDuration()}
                {arrowOpen && renderExpendedData(packageData)}
            </>
        );
    }

    function displayPackageExpandedDuration() {
        if (
            !packageData.socExpDate ||
            (packageData.isBankOrByUse == 'ByUse' && (packageDuration == null || packageDuration == undefined || packageDuration == 0))
        )
            return;

        const durationLine = `תוקף החבילה שבחרת: ${formatPackageDurationLabel(packageDuration, packageDurationUnit)}`;
        const dateBeforeEffDate = getDayBeforeAndAfter(formatDateToMonthFirst(packageData.socEffactiveDate), true);
        const startPackage = formatDatesToDifferentFormats(formatDateToMonthFirst(packageData.socEffactiveDate)).formattedUI.slice(0, 5);
        const endPackage = formatDatesToDifferentFormats(formatDateToMonthFirst(packageData.socExpDate)).formattedUI.slice(0, 5);
        const dayAfterEndDay = getDayBeforeAndAfter(formatDateToMonthFirst(packageData.socExpDate), false);
        if (packageDuration != null) {
            return (
                <div className='package-data-line'>
                    <div className='just-data'>
                        <div className='just-data-heading'>{durationLine}</div>
                        {formatPackageFromToDatesLine(dateBeforeEffDate, startPackage, endPackage, dayAfterEndDay)}
                    </div>
                </div>
            );
        }
        return null;
    }

    function formatPackageFromToDatesLine(dateBeforeEffDate, startPackage, endPackage, dayAfterEndDay) {
        return (
            <div className='just-data-text'>
                <div className='first-line'>
                    החבילה תתחיל ב-{packageData.effDateILLocalTime} בלילה שבין ה-
                    {dateBeforeEffDate} ל-{startPackage}
                </div>
                <div className='second-line'>
                    ותסתיים ב-
                    {packageData.expDateILLocalTime} בלילה שבין ה-{endPackage} ל-{dayAfterEndDay}
                </div>
            </div>
        );
    }

    function renderPackageWillOccurAt() {
        return extraTopShouldShow && <div className='extra-top'> <Image src={calendarIcon} className='calendar-icon' />
            תחילת חבילה {dateTxt}</div>;
    }

    function setUpdateTripDateAndReportGA() {
        gaEvent(
            gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_DATE_CHANGE.category,
            gaParams.ABROAD_MY_ABROAD_PACKAGE_EXISTS_CLICK_DATE_CHANGE.eventType,
            packageSocCode,
        );
        if (canChangeStartDatePackageFamily) setPopUpDisplay(popUpObject.updateTripDate);
        else setPopUpDisplay(popUpObject.cantChangeStartDateFamilyOrCanCancelFamily);
    }

    function renderPackageAvailableActions(packageData) {
        const canChangeTrip = packageData?.permissions?.canChangeTripStartDate === true || false;
        const canSeeCancelPackageBtn = packageData?.permissions?.shouldShowCancelBtn === true || false;

        // If it's a family bundle, only flight manager can edit
        let canChangeTripEffective = canChangeTrip;
        let canSeeCancelPackageBtnEffective = canSeeCancelPackageBtn;
        if (packageData?.isFamilyBundle) {
            const flightManager = packageData.familyBundleData?.subscribers?.find(s => s.isManager === true)?.subscriberNo;
            const isFlightManager = flightManager === mobile;
            canChangeTripEffective = canChangeTrip && isFlightManager;
            canSeeCancelPackageBtnEffective = canSeeCancelPackageBtn && isFlightManager;
        }

        const hasAction = canChangeTripEffective || canSeeCancelPackageBtnEffective;

        if (hasAction) {
            return (
                <div className='action-container'>
                    {canChangeTripEffective && packageData.socType == AbroadSocType.REGULAR_SOC && (
                        <div className='update-date-action' onClick={() => setUpdateTripDateAndReportGA()}>
                            {'עדכון תאריך התחלה'}
                        </div>
                    )}
                    {canSeeCancelPackageBtn && (
                        <div className='cancel-package-action' onClick={() => displayCancelPopUpAndReportGA()}>
                            {'ביטול חבילה'}
                        </div>
                    )}
                </div>
            );
        }
        return null;
    }


    function handleEditFamilyMembers() {
        setFamilyMembersEditMode('edit');

        if (isOtpMode && !otpExtendedDone) {
            console.log('[SelfCareExsitingPackage] Showing OTP extended popup');
            setShowOtpExtendedPopup(true);
            return;
        }
        // Pre-populate Redux with the package's current members so the popup shows them as selected
        const currentMembers = packageData.familyBundleData?.subscribers
            ?.filter(s => s.isManager === false)
            ?.map(s => ({ phone: s.subscriberNo })) || [];
        setSelectedMembers(currentMembers);
        setPopUpDisplay(popUpObject.showFamilyMembersPopup);
    }

    function handleAddFamilyMembers() {
        setFamilyMembersEditMode('add');

        if (isOtpMode && !otpExtendedDone) {
            console.log('[FamilyBundleSection] Showing OTP extended popup');
            setShowOtpExtendedPopup(true);
            return;
        }

        setPopUpDisplay(popUpObject.showFamilyMembersPopup);
    }

    function renderFamilyBundleMembersSection(packageData) {
        if (!packageData?.isFamilyBundle) return null;

        const flightManager = packageData.familyBundleData?.subscribers?.find(s => s.isManager === true)?.subscriberNo;
        const bundleMembers = packageData.familyBundleData?.subscribers
            ?.filter(s => s.isManager === false)
            ?.map(s => {
                const found = (cellularSubscribers || []).find(cs => cs.productSubscriberNo === s.subscriberNo);
                const name = found ? `${found.productFirstName || ''} ${found.productLastName || ''}`.trim() : '';
                return { phone: s.subscriberNo, name };
            }) || [];
        // Only show if we have flight manager or members
        if (!flightManager && bundleMembers.length === 0) return null;

        const isFlightManager = flightManager === mobile;
        const canEdit = isFlightManager && !hasSevenDaysPassedSinceEffectiveDate();
        const isFuturePackage = checkEffDateBiggerThenToday();

        // Extract member display details (handle both string and object formats)
        const getMemberDisplay = (member) => {
            if (member?.phone && member?.name) return `${member.phone} ${member.name}`;
            if (member?.phone) return member.phone;
            return '';
        };

        const subscriberRedactedNumber = flightManager ? `${flightManager.slice(0, 4)}***${flightManager.slice(-3)}` : 'מספר טלפון לא זמין';

        // Flight manager view - show member list with edit option
        if (isFlightManager) {
            return (
                <div className='family-bundle-members-container'>
                    <div className='family-bundle-title'>
                        <span>חבילה משפחתית</span>
                        <CustomTooltip
                            placement="top"
                            content={
                                <>
                                    ניתן לצרף לחבילה מנוי סלולרי משולמים ע"י אותו בעל ת.ז ומאותו אמצעי תשלום.<br />
                                    בנוסף ניתן לשנות את תאריך התחלת החבילה כך שלא יתחיל באותו התאריך של החבילה הראשית. שימו לב כי חבילת בני משפחה הינה לאותם יעדים של החבילה הראשית שנרכשתם
                                </>
                            }
                        >
                            <span className="info-icon">
                                <Image src={moreInfoIcon} alt="info" />
                            </span>
                        </CustomTooltip>
                    </div>
                    {bundleMembers.map((member, index) => (
                        <div key={index} className='member-row'>
                            <Image src={userIcon} className='user-icon' alt='user' />
                            <span className='member-name'>{getMemberDisplay(member)}</span>
                        </div>
                    ))}

                    {canEdit && (
                        <div
                            className='edit-members-link'
                            onClick={isFuturePackage ? handleEditFamilyMembers : handleAddFamilyMembers}
                        >
                            <Image src={editIcon} className='edit-icon' alt='edit' />
                            <span>{isFuturePackage ? 'עדכון מנויים' : 'להוספת מנויים'}</span>
                        </div>
                    )}
                </div>
            );
        }

        // Non-flight manager view - show contact notice
        else if (packageData && isPackageActive(packageData.socEffactiveDate)) {
            return (
                <div className='family-bundle-notice-container'>
                    <div className='family-bundle-notice'>
                        <div className='notice-icon-container'>
                            <Image src={noticeIcon} className='notice-icon' alt='info' />
                        </div>
                        <div className='notice-text'>
                            לשינויים בחבילה המשפחתית יש לפנות למנהל הטיסה - <span dir="ltr">{subscriberRedactedNumber}</span>
                        </div>
                    </div>
                </div>
            );
        }
    }

    function closePopUp() {
        setPopUpDisplay('');
    }

    function handlePackageCanceledClose() {
        closePopUp();
        resetSocPackageRemoveStatus();
        dispatch(clearPurchasedFamilyBundleData());
        setChosenSocForAction(null);
        getCustomerAbroadPackages({
            mobile,
            privateBlockId: privateId,
            businessBlockId: businessId,
            goldBusinessPackagesBlockId: goldBusinessSocPackageFolderId,
            addonsFolderBlockId: iContent.linkForAddonsPackages?.value?.id,
            noLoader: true,
        });
    }

    function handleFamilyBundleEditSuccess() {
        closePopUp();
        dispatch(clearPurchasedFamilyBundleData());
        dispatch(resetAllAbroadSubscribers())
    }

    const updateSocPackage = async (startDate) => {
        gaEvent(
            gaParams.ABROAD_MY_ABROAD_CLICK_CHANGE_START_DATE_POP_UP.category,
            gaParams.ABROAD_MY_ABROAD_CLICK_CHANGE_START_DATE_POP_UP.eventType,
            gaParams.ABROAD_MY_ABROAD_CLICK_CHANGE_START_DATE_POP_UP.eventParams,
        );
        const d = formatDatesToDifferentFormats(startDate);
        const exp = formatDatesToDifferentFormats(new Date());
        const newUpdatedDate = d.formattedProvider;
        const privateIdPerProcess = abroadWorld ? iContent.linkForPrivatePackages?.value?.id : privateId;
        const businessIdPerProcess = abroadWorld ? iContent.linkForBusinessPackages?.value?.id : businessId;
        const goldBusinessIdPerProcess = abroadWorld ? iContent.linkForBusinessGoldPackages?.value?.id : goldBusinessSocPackageFolderId;
        const addonsIdPerProcess = abroadWorld
            ? iContent.linkForAddonsPackages?.value?.id
            : cellcomAbroad.epiStyleInitializationData.addonsPackagesFolderId;
        const noLoaderPerProcess = abroadWorld ? true : false;
        const data = {
            phoneNumber: mobile,
            soc: packageSocCode,
            effDate: packageData.socEffactiveDate,
            expDate: exp.formattedProvider,
            newDateToUpdate: newUpdatedDate,
            businessId: businessIdPerProcess,
            goldBusinessPackagesBlockId: goldBusinessIdPerProcess,
            addonsFolderBlockId: addonsIdPerProcess,
            noLoader: noLoaderPerProcess,
            blockId: packageBlockId,
        };
        if (isBusinessIndividual) {
            data.isBusinessIndividual = true;
            data.goldBusinessPackagesBlockId = goldBusinessIdPerProcess;
            data.orgId = portalsBlock.privateCompanyList.find((org) => org.idNumber == portalsBlock.selectedHetPay).orgId;
        } else {
            data.isBusinessIndividual = false;
            data.privateId = privateIdPerProcess;
        }
        setChosenSocForAction(packageSocCode);
        closePopUp();
        await updatePackage(data);
    };

    const localStatePopUpHasValue = () => {
        return popUpDisplay != '' ? true : false;
    };
    const showBusinessTerms = async () => {
        const url = `${Config.termsUrl}?socCode=${packageSocCode}`;
        let win = window.open(url, '_blank');
        win.focus();
    };
    const openAgreementPDF = async () => {
        prepareUrl(packageData.abroadPackageClient?.policiesEpi, EpiContext);
    };
    const GetStartDateParent = (dateParent) => {
        if (dateParent) {
            let year = dateParent.substring(0, 4);
            let month = dateParent.substring(4, 6);
            let day = dateParent.substring(6, 8);
            let date = new Date(year, month - 1, day);
            let rightFormat = formatDatesToDifferentFormats(new Date(date))?.formattedISOS;
            return rightFormat;
        }
    };

    const handleOtpExtendedFinished = async () => {
        setShowOtpExtendedPopup(false);
        await setRetainSubscriberOnLoad(true);
        // Set the callback name in Redux BEFORE flipping otpExtendedDone,
        // so the useEffect reads the correct value when it fires.
        if (familyMembersEditMode === "edit") {
            await setCallbackAfterExtendedLogin("handleEditFamilyMembers");
        } else if (familyMembersEditMode === "add") {
            await setCallbackAfterExtendedLogin("handleAddFamilyMembers");
        }
        setOtpExtendedDone(true);
    };

    function renderPopUps(packageData) {
        const extraInfoTxt = Array.isArray(packageData?.abroadPackageClient?.importantInfo)
            ? packageData.abroadPackageClient.importantInfo
            : '';
        return (
            <>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.failedUpdatePackage} onClose={closePopUp}>
                    {popUpDisplay === popUpObject.failedUpdatePackage && (
                        <FailedUpdatePackage
                            onClose={() => {
                                closePopUp();
                                resetSocPackageRemoveStatus();
                            }}
                        />
                    )}
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showInfoPopUp} onClose={closePopUp}>
                    {hasImportantDataText && (
                        <ImportantPart
                            importantInfo={extraInfoTxt}
                            policiesEpi={packageData.abroadPackageClient?.policiesEpi}
                            showBusinessTerms={showBusinessTerms}
                            openAgreementPDF={openAgreementPDF}
                        />
                    )}
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showCountriesPopUp} onClose={closePopUp}>
                    <CountryPopUp onClose={closePopUp} packageSocCode={packageSocCode} />
                </PopUp>
                <PopUp
                    showPopUp={
                        localStatePopUpHasValue &&
                        (popUpDisplay === popUpObject.updateTripDate || popUpDisplay === popUpObject.showChangeStartDateFamily)
                    }
                    onClose={closePopUp}>
                    <ChangeStartPackageDatePopup
                        buttonText={'עדכון תאריך התחלה'}
                        isFamilyBonus={packageData.abroadPackageClient?.isFamilyBonus}
                        fromPackageManager={true}
                        startDate={changeDateToJSFormat()}
                        action={(startDate) => updateSocPackage(startDate)}
                        title={'עדכן תאריך התחלה'}
                        description={
                            packageData.abroadPackageClient?.isFamilyBonus
                                ? `<span class="bold">רגע, זה חשוב</span><br /> חבילת בני משפחה לא יכולה להתחיל מעבר ל 7 ימים מתחילת החבילה הראשית`
                                : ``
                        }
                        startDateParent={packageData.abroadPackageClient?.isFamilyBonus ? GetStartDateParent(packageData?.startDateParent) : null}
                    />
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showCancelPackagePopUp} onClose={closePopUp}>
                    {packageData.socType == AbroadSocType.ADDON_SOC ? (
                        <CancelAddonPackagePopUp
                            cancelPackage={cancelPackage}
                            onClose={closePopUp}
                            dwhParams={params}
                            socTitle={packageData.customTitle}
                        />
                    ) : (
                        <CancelPackagePopUp cancelPackage={cancelPackage} onClose={closePopUp} />
                    )}
                </PopUp>
                <PopUp
                    className='cancellation-notice-popup'
                    showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showAddonsCancellationNoticePopUp}
                    onClose={closePopUp}>
                    <AddonsCancellationNoticePopup addons={addonsUnderPackage} onClose={() => setPopUpDisplay(popUpObject.showCancelPackagePopUp)} />
                </PopUp>
                <PopUp
                    showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.cantChangeStartDateFamilyOrCanCancelFamily}
                    onClose={closePopUp}>
                    <CantChangeStartDateFamilyOrCanCancelFamily
                        cancelPackage={cancelPackage}
                        onClose={closePopUp}
                        isPermissive={canCancelPackageFamily}
                    />
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showYouCannotCancelPackagePopUp} onClose={closePopUp}>
                    <FailedUpdatePackage
                        cancelPackage={cancelPackage}
                        onClose={closePopUp}
                        cancelPopUpText={packageData.permissions?.cancelPopUpText}
                    />
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.displayStateInclude} onClose={closePopUp}>
                    <AbroadStateInclude stateInclude={packageData?.abroadPackageClient?.countrySupportedDictionary} />
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.failedCancelPackage} onClose={closePopUp}>
                    <FailedCancelPackage onClose={closePopUp} resetSocPackageRemoveStatus={resetSocPackageRemoveStatus} />
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showCannotCancelWhileAbroadPopUp} onClose={closePopUp}>
                    <CannotCancelWhileAbroad onClose={closePopUp} resetSocPackageRemoveStatus={resetSocPackageRemoveStatus} />
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showFamilyMembersPopup} onClose={closePopUp}>
                    <SelectFamilyMembersPopup
                        availableMembers={(cellularSubscribers || []).map(subscriber => ({
                            id: subscriber.productSubscriberNo,
                            phone: subscriber.productSubscriberNo,
                            name: `${subscriber.productFirstName} ${subscriber.productLastName}`.trim(),
                            ...subscriber
                        }))}
                        flightManager={{
                            phone: packageData.familyBundleData?.subscribers?.find(s => s.isManager === true)?.subscriberNo,
                            name: ''
                        }}
                        multipleBans={false}
                        editMode={familyMembersEditMode}
                        existingMembers={packageData.familyBundleData?.subscribers?.filter(s => s.isManager === false)?.map(s => ({ phone: s.subscriberNo })) || []}
                        socCode={packageSocCode}
                        abroadLobbyBlockId={lobbyBlockId || packageBlockId}
                        startDate={getFamilyMembersPopupStartDate()}
                        endDate={packageData?.socExpDate}
                        countries={Object.keys(packageData.abroadPackageClient?.countrySupportedDictionary || {})}
                        accountType={cellcomAbroad.activeLobbyTab === 'businessAccount' ? customerTypeEnum.BUSINESS : customerTypeEnum.PRIVATE}
                        onError={() => setPopUpDisplay(popUpObject.showFamilyBundleError)}
                        onContinue={handleFamilyBundleEditSuccess}
                    />
                </PopUp>
                <PopUp className='packageCanceledPopup' showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showPackageCanceledPopup} onClose={handlePackageCanceledClose}>
                    <PackageCanceledPopup
                        onClose={handlePackageCanceledClose}
                    />
                </PopUp>
                <PopUp showPopUp={localStatePopUpHasValue && popUpDisplay === popUpObject.showFamilyBundleError} onClose={closePopUp}>
                    {popUpDisplay === popUpObject.showFamilyBundleError && (
                        <FamilyBundleErrorPopup
                            errorType={familyBundleData?.errorType || 'members'}
                            flightManager={familyBundleData?.flightManager}
                            failedMembers={familyBundleData?.failedMembers || []}
                            onSelectDifferentFlightManager={() => {
                                resetFamilyBundleData();
                                closePopUp();
                            }}
                            onContinueWithRest={() => {
                                resetFamilyBundleData();
                                closePopUp();
                            }}
                            onCancelPackage={async () => {
                                resetFamilyBundleData();
                                await cancelPackage();
                            }}
                            onClose={() => {
                                resetFamilyBundleData();
                                closePopUp();
                            }}
                            onTurnOnCellularData={() => {
                                resetFamilyBundleData();
                                closePopUp();
                            }}
                        />
                    )}
                </PopUp>

                {showOtpExtendedPopup && (
                    <PopUpWithAnimation
                        className='selfcareExtendedOtpPopUp'
                        isShow={showOtpExtendedPopup}
                        onClose={() => setShowOtpExtendedPopup(false)}
                    >
                        <OtpExtendedPopup
                            setShowPopUp={setShowOtpExtendedPopup}
                            showPopup={showOtpExtendedPopup}
                            setOtpExtendedFinished={handleOtpExtendedFinished}
                            title={'כדי להוסיף בני משפחה צריך אישור מורחב'}
                            subTitle={'נשלח לכם קוד אימות נוסף שאיתו תוכלו להמשיך'}
                        />
                    </PopUpWithAnimation>
                )}
            </>
        );
    }

    function getRightDateArr(dateArr) {
        const secondDate = new Date(parseInt(dateArr[2]), parseInt(dateArr[1]) - 1, parseInt(dateArr[0]));
        const today = new Date();
        if (today.getTime() > secondDate.getTime()) return [today.getDate(), today.getMonth() + 1, today.getFullYear()];
        else return [dateArr[0], dateArr[1], dateArr[2]];
    }

    async function getPackageForFamilyMember() {
        // TBD send to ticket to buy with data
        if(HasReducedSocs) {
            await setReducedSocsForFamilyMember({
                  socCode: packageData?.abroadPackageClient?.socCode,
                  //linkToSaleBlockProcess: linkForSaleBlockProcess,
                  //reducedSocsBlockId: iContent.linkForRelatedReducedPackages?.value?.id
            });
            await buildUrlAndNavigate(linkForRelatedReducedPackages);
            return;
        }
        gaEvent(
            gaParams.ABROAD_FAMILY_CLICK_ADD_FAMILY_MEMBER_PACKAGE.category,
            gaParams.ABROAD_FAMILY_CLICK_ADD_FAMILY_MEMBER_PACKAGE.eventType,
            familyMembersWithPackages.length,
        );

        if (packageData?.canPurchaseFamilyPackage === true) {
            const tempDatePickerStartJSFormat = packageData?.effDateILLocalTime.split('.');
            const correctDateArray = getRightDateArr(tempDatePickerStartJSFormat);
            const datePickerStartJSFormat = [correctDateArray[1], correctDateArray[0], correctDateArray[2]].join('/');
            const correctSelectedStartDate = [correctDateArray[0], correctDateArray[1], correctDateArray[2]].join('.');

            const objToUpdateTicket = {
                selectedPackage: packageData?.familyMemberDiscountedPackage,
                folderType: packageData?.isBusiness ? customerTypeEnum.BUSINESS : customerTypeEnum.PRIVATE,
                selectedStartDate: correctSelectedStartDate,
                datePickerStartJSFormat,
                parentStartDate: [tempDatePickerStartJSFormat[1], tempDatePickerStartJSFormat[0], tempDatePickerStartJSFormat[2]].join('/'),
                countryList: packageData?.familyMemberDiscountedPackage?.countrySupportedList,
                socCodeParent: packageData?.abroadPackageClient?.socCode,
            };
            setLoading(true);
            await updateTicketFromPackageManager(objToUpdateTicket);
            setRetainSubscriberOnLoad(true);
            await buildUrlAndNavigate(linkForSaleBlockProcess);
        }
    }

    function renderFamilyMemberMobileRow() {
        return (familyMembersWithPackages || []).map(function (mobile, i) {
            return (
                <div className='phone-row' key={i}>
                    <div className='dot-img-wrapper'>
                        <Image className='dot-img' src={dot} alt='dot-img' />
                    </div>
                    <div className='phone-soc-wrapper'>
                        <div className='phone'>{mobile}</div>
                        <div className='soc'>{packageData?.familyMemberDiscountedPackage?.familyPackageDescriptionFromPackageManager}</div>
                    </div>
                </div>
            );
        });
    }

    function renderPicBoxes() {
        return (familyMembersWithPackages || []).map(function (element, i) {
            return (
                <div key={element} className={`marker-wrapper`}>
                    <Image className='marker-pic' src={marker}></Image>
                </div>
            );
        });
    }

    function renderAddBoxes(boxesLeft) {
        const emptyBoxes = Array(boxesLeft).fill('');
        if (canPurchaseFamilyPackage) {
          return (emptyBoxes || []).map(function (element, i) {
            return (
              <div className='slot-text-container' key={i} onClick={() => getPackageForFamilyMember()}>
                <div className='slot-add-text'>הוספה </div>
                <div className='slot-add-sign-container'>
                  <Image src={addIcon} className='slot-add-sign-img' alt='add' />
                </div>
              </div>
            );
          });
        }
        return null;
      }

    function renderBottomFamilyTxtLine() {
        if (familyMembersWithPackages.length > 0) {
            return (
                <>
                    <div className='horizontal-line'></div>
                    <div className='family-box-bottom'>לניהול החבילות המשפחתיות צריך להתנתק ולהתחבר לאזור חו"ל שלי עם מספר המנוי שרוצים לעדכן</div>
                </>
            );
        }
        return null;
    }

    const backgroundConfettiImage = isMobile ? confettiMobile : confettiDesktop;

    function renderFamilyRelatedPackages() {
        if( HasReducedSocs ) {
            maxFamilyMembers = reducedSocs?.maxFamilyMembers;
          }
        let boxesLeft = maxFamilyMembers - familyMembersWithPackages.length;
        boxesLeft = boxesLeft < 0 ? 0 : boxesLeft;
        
            return (
                <div className='family-box-container' style={{ backgroundImage: backgroundConfettiImage.bg() }}>
                    <div className='family-box-upper'>
                        <div className='txt-section'>
                            <div className='family-header'>
                                הטבת חו"ל משפחתי
                                <AbroadTooltip tooltipText={isBrowser ? toolTipFamily : ''} tooltipId={'family-package-tooltip'} placement={'bottom'} />
                            </div>
                            <div className='family-p'>
                            איזה כיף! קיבלת הטבה ל- {maxFamilyMembers} בני המשפחה <br />
                            במסגרת חבילת {packageData?.abroadPackageClient?.titleEpi}
                            </div>
                        </div>
                        <div className='family-box-slots'>
                            {renderPicBoxes()}
                            {renderAddBoxes(boxesLeft)}
                        </div>
                    </div>
                    <div className='phone-section-mid'>{renderFamilyMemberMobileRow()}</div>
                    {renderBottomFamilyTxtLine()}
                </div>
            );
 
    }

    return (
        <>
            <div className='package-box'>
                {renderPackageWillOccurAt()}
                <div className={`top-box${arrowOpen ? ' open' : ''} ${extraTopShouldShow ? ' extra-top-box' : ''} ${!packageData?.permissions?.canChangeTripStartDate &&
                    !packageData?.permissions?.shouldShowCancelBtn &&
                    packageData?.is &&
                    packageData.familyBundleData?.subscribers?.find(s => s.isManager === true)?.subscriberNo !== mobile
                    ? ' no-border'
                    : ''
                    }`}>
                    <div className='package-header-line'>
                        <div className='package-header'>{packageTitle}</div>
                        <Image alt='arrow' className={`arrow-img${arrowOpen ? ' open' : ''}`} src={images.arrow} onClick={() => expendData()}></Image>
                    </div>
                    {packageData.isFoundedByTheCompany && (
                        <div className='full-funding' style={{ color: 'var(--theme-primary, #9631ff)', fontSize: '32px' }}>
                            חבילה במימון החברה{' '}
                        </div>
                    )}
                    {renderPackageData(packageData)}
                </div>
                {renderPackageAvailableActions(packageData)}
                {renderFamilyBundleMembersSection(packageData)}

                {renderPopUps(packageData)}
            </div>
            {(canPurchaseFamilyPackage || familyMembersWithPackages.length > 0) && renderFamilyRelatedPackages()}
            </>
    );
}

const mapStateToProps = (state) => ({
    cellcomAbroad: state.cellcomAbroad,
    authentication: state.authentication,
    otpData: state.cellcomAbroad.otpData,
    socPackageRemoveStatus: state.cellcomAbroad.socPackageRemoveStatus,
    socPackageRemoveErrorCode: state.cellcomAbroad.socPackageRemoveErrorCode,
    businessId: state.cellcomAbroad.epiStyleInitializationData.businessSocPackageFolderId,
    goldBusinessSocPackageFolderId: state.cellcomAbroad.epiStyleInitializationData.goldBusinessSocPackageFolderId,
    privateId: state.cellcomAbroad.epiStyleInitializationData.privateSocPackageFolderId,
    mobile: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby
        ? state.cellcomAbroad.businessIndividualData.selectedAccountNumber
        : state.selfcarePage.selectedSubscriber?.productSubscriberNo || state.authentication.loginData.userDetails.contactNumber,
    updatedSocResultStatus: state.selfcarePage.selectedSubscriber?.abroadPackages?.updatePackageSucceded,
    chosenSocForAction: state.cellcomAbroad.chosenSocForAction,
    isBusinessIndividual: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
    portalsBlock: state.portalsBlock,
    userData: state.authentication?.loginData?.userDetails,
    selfcareAbroadAddons: state.selfcarePage.selectedSubscriber.abroadAddons,
    selfCareAbroadPackages: state.selfcarePage.selectedSubscriber?.abroadPackages?.regularPackages,
    removePackageSucceded: state.selfcarePage.selectedSubscriber?.abroadPackages?.removePackageSucceded,
    purchasedFamilyBundleData: state.cellcomAbroad.purchasedFamilyBundleData,
    cellularSubscribers: state.selfcarePage?.subscribersByProduct?.Cellular,
    familyBundleData: state.cellcomAbroad.familyBundleData,
    lobbyBlockId: state.selfcarePage.worlds?.abroad?.abroadLobbyBlockId,
    callbackAfterExtendedLogin: state.selfcarePage?.callbackAfterExtendedLogin
});

const mapDispatchToProps = {
    abroadCountriesSearched,
    removePackage,
    setLoading,
    updatePackage,
    updateTicketFromPackageManager,
    resetSocPackageRemoveStatus,
    invalidateAbroadDataForSubscriber,
    saveToHistory,
    setChosenSocForAction,
    getCustomerAbroadPackages,
    clearScreenILAddon,
    filterCustomerFromBoughtPackages,
    setRetainSubscriberOnLoad,
    resetFamilyBundleData,
    setSelectedMembers,
    setCallbackAfterExtendedLogin,
    setReducedSocsForFamilyMember
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCareExistingPackage);
